/* sucrase/dist/esm/Options.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.validateOptions = validateOptions;
    const tslib_1 = require("tslib");
    const ts_interface_checker_1 = require("566f6e7d92") /* ts-interface-checker */;
    const Options_gen_types_1 = tslib_1.__importDefault(require("26465ac544") /* ./Options-gen-types */);
    const { Options: OptionsChecker } = (0, ts_interface_checker_1.createCheckers)(Options_gen_types_1.default);
    function validateOptions(options) {
        OptionsChecker.strictCheck(options);
    }
}
